import React, {Component} from 'react'
import {ReactComponent as AngleRightIcon} from '@shop/icon-fonts/optimized/angle-right-mid.svg'
import AppContext from '../../context'
import Multilanguage from '../Multilanguage'
import * as SC from './BurgerNavigation.styled'
import {PrimaryIcon} from '../Icon/Icon.styled'
import BurgerHeader from './BurgerHeader'
import {DEVICE_TYPES} from '../../utils'

class BurgerNavigation extends Component {
  static contextType = AppContext

  constructor(props) {
    super(props)
    this.state = {
      panelsMap: new Map()
    }
  }

  componentDidMount() {
    const {categories} = this.context
    const panelsMap = categories.reduce(this.getReducer(), new Map())
    this.setState({panelsMap})
  }

  /**
   * High Order Function to be able to pass auxiliar variables to reduce
   * callback function and store previous and current category properties in the current panel
   *
   * @param currentId(number)
   * @param parentId(number)
   * @param parentTitle(string)
   * @param isSpecial(boolean)
   * @returns {function(Map, Category): Map}
   */
  getReducer = (currentId = -1, currentTitle, currentPath, parentId, parentTitle, isSpecial = false) => {
    return (map, category) => {
      const {children, specials, extId, title, path} = category
      const items = map.has(currentId) ? map.get(currentId).items : []

      const transformedCategory = this.transformCategory(category)
      items.push({...transformedCategory, isSpecial})

      let panelData = {items, show: currentId < 0, currentId}
      if (currentId > 0) {
        panelData = {...panelData, currentTitle, currentPath}
      }
      if (parentId) {
        panelData = {...panelData, parentId, parentTitle}
      }
      map.set(currentId, panelData)

      if (children && children.length) {
        children.reduce(this.getReducer(extId, title, path, currentId, currentTitle), map)
      }

      if (specials && specials.length) {
        specials.reduce(this.getReducer(extId, title, path, currentId, currentTitle, true), map)
      }
      return map
    }
  }

  transformCategory = (category) => {
    const {children, specials} = category
    const hasChildren = Boolean((children && children.length) || (specials && specials.length))
    const transformed = Object.entries(category)
      .filter(([key, value]) => typeof value !== 'object' && key !== 'whitespaceAfter')
      .reduce((prev, [key, value]) => ({...prev, [key]: value}), {})
    return {...transformed, hasChildren}
  }

  onClickPrevPanel = (currentPanelId) => {
    const {panelsMap} = this.state
    const currentPanel = panelsMap.get(currentPanelId)
    currentPanel.show = false
    this.setState({panelsMap: new Map(panelsMap)})
  }

  onClickNextPanel = (nextPanelId) => {
    const {panelsMap} = this.state
    const nextPanel = panelsMap.get(nextPanelId)
    nextPanel.show = true
    this.setState({panelsMap: new Map(panelsMap)})
  }

  render() {
    const {clientWidth, device, translations, multilanguage} = this.context
    const {panelsMap} = this.state
    const hidden = device !== DEVICE_TYPES.SMARTPHONE && device !== DEVICE_TYPES.PHABLET
    if (!panelsMap.size || hidden) {
      return null
    }

    const openPanels = Array.from(panelsMap.values())
      .filter(panel => (panel.show))
    const panelsCount = openPanels.length
    const currentPanel = openPanels.slice(-1)[0]
    const {currentId} = currentPanel
    const panelWrapperWidth = panelsCount * clientWidth
    const offset = (panelsCount - 1) * clientWidth
    const accessibleLabel = translations.get('shop.header.main.navigation.category.accessible.button.label')

    return (
      <SC.BurgerNav>
        <BurgerHeader
          currentPanel={currentPanel}
          onClickPrevPanel={this.onClickPrevPanel}
          translations={translations}
        />
        <SC.BurgerPanelsWrapper
          hasMultilanguage={multilanguage}
          style={{width: `${panelWrapperWidth}px`, left: `-${offset}px`}}
        >
          {openPanels.map(panel => (
            <SC.BurgerPanel
              key={panel.currentId}
              style={{width: `${clientWidth}px`}}
            >
              {panel.items.map((item) => {
                const {extId, path, title, hasChildren, isSpecial} = item
                return (
                  <SC.BurgerItem
                    key={extId}
                  >
                    {!hasChildren
                      && <SC.BurgerItemLink
                        href={currentId === panel.currentId ? path : null}
                        isSpecial={isSpecial}
                      >
                        {title}
                      </SC.BurgerItemLink>}

                    {hasChildren
                      && <SC.BurgerItemButton
                        onClick={() => this.onClickNextPanel(extId)}
                        disabled={currentId !== panel.currentId}
                      >
                        {title}
                        <PrimaryIcon>
                          <AngleRightIcon aria-label={accessibleLabel} data-zta="angleRightIcon" />
                        </PrimaryIcon>
                      </SC.BurgerItemButton>}
                  </SC.BurgerItem>
                )
              })}
            </SC.BurgerPanel>
          ))}
        </SC.BurgerPanelsWrapper>
        {multilanguage
          && <Multilanguage />}
      </SC.BurgerNav>
    )
  }
}

export default BurgerNavigation
